import React from "react";
import { Mail, Lock, Zap } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-[#F4EBDE] border-t border-[#E8DDC9] py-14 md:py-16"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="font-serif-display text-2xl text-[#2A302A] leading-none">
              Pequeños Platos
            </div>
            <p className="text-[10px] tracking-[0.3em] uppercase text-[#8A948A] mt-2 font-medium">
              Nutrición que abraza
            </p>
            <p className="text-sm text-[#576057] mt-5 max-w-md leading-relaxed">
              Acompañamos a miles de mamás a alimentar a sus hijos con amor,
              practicidad y tranquilidad — desde los primeros alimentos hasta los 15
              años.
            </p>
          </div>

          {/* Soporte */}
          <div className="md:col-span-3">
            <h4 className="text-[11px] tracking-[0.22em] uppercase font-semibold text-[#849983]">
              Soporte
            </h4>
            <a
              data-testid="footer-contact"
              href="mailto:contato@pequenosplatos.com"
              className="mt-4 inline-flex items-center gap-2 text-sm text-[#2A302A] hover:text-[#849983] transition break-all"
            >
              <Mail className="h-4 w-4 shrink-0" />
              contato@pequenosplatos.com
            </a>
          </div>

          {/* Trust */}
          <div className="md:col-span-4">
            <h4 className="text-[11px] tracking-[0.22em] uppercase font-semibold text-[#849983]">
              Compra segura
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-[#2A302A]">
              <li className="flex items-center gap-2">
                <Lock className="h-4 w-4 text-[#849983]" />
                Pago 100% seguro
              </li>
              <li className="flex items-center gap-2">
                <Zap className="h-4 w-4 text-[#849983]" />
                Acceso inmediato después de la compra
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#E8DDC9] flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-[#8A948A]">
          <p>© {new Date().getFullYear()} Pequeños Platos. Todos los derechos reservados.</p>
          <div className="flex items-center gap-6">
            <a
              data-testid="footer-privacy"
              href="#"
              className="hover:text-[#2A302A] transition"
            >
              Política de privacidad
            </a>
            <a
              data-testid="footer-terms"
              href="#"
              className="hover:text-[#2A302A] transition"
            >
              Términos y condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
